import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { handleLinkedInLogin } from '../../services/api';

export const LinkedIn = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (code) {
            handleLinkedInLogin(code)
                .then((userInfo) => {
                    localStorage.setItem('linkedin_user_info', JSON.stringify(userInfo));
                    setLoading(false);
                    navigate('/registration-setup', { state: userInfo });
                })
                .catch((error) => {
                    setLoading(false);
                    navigate('/registration-setup', { state: { error: error.message } });
                });
        } else {
            setLoading(false);
            navigate('/registration-setup', { state: { error: 'No LinkedIn code provided' } });
        }
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            {loading ? (
                <>
                    <Spinner className="w-8 h-8 text-blue-600" />
                    <p className="mt-4 text-sm text-gray-600">Verifying LinkedIn login...</p>
                </>
            ) : (
                <p className="text-green-600 font-semibold">Redirecting to dashboard...</p>
            )}
        </div>
    );
};